module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-game-mode-options"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-block",
    attrs: {
      "type": "button",
      "disabled": _vm.isGameRunning
    },
    on: {
      "click": _vm.startGame
    }
  }, [_vm._v(_vm._s(_vm.$t("game.play")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-block",
    attrs: {
      "type": "button",
      "disabled": !_vm.isGameRunning
    },
    on: {
      "click": _vm.stopGame
    }
  }, [_vm._v(_vm._s(_vm.$t("game.stop")))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-5"
  }, [_vm._v(_vm._s(_vm.$t("sidebar.legend")))]), _vm._v(" "), _c('periodic-table-options')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4063f2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/GameModeOptions.vue
// module id = 652
// module chunks = 1